import { UzFormField, UzInput } from '@utazzo/ui';
import { useFieldArray, type UseFormReturn } from 'react-hook-form';

import type { CreateWebsiteCategoryPageRequest } from '@utazzo/shared';

import { AddRowButton, RowShell } from '@/features/destination-pages/components/RowShell';
import { RichTextEditor } from '@/features/website-cms/components/RichTextEditor';

export const FaqsEditor = ({
  form,
  disabled,
}: {
  form: UseFormReturn<CreateWebsiteCategoryPageRequest>;
  disabled?: boolean;
}) => {
  const { fields, append, remove, move } = useFieldArray({ control: form.control, name: 'faqs' });
  return (
    <div className="space-y-3">
      {fields.map((f, i) => (
        <RowShell
          key={f.id}
          index={i}
          total={fields.length}
          disabled={disabled}
          onMove={move}
          onRemove={remove}
        >
          <UzFormField name={`faqs.${i}.question` as const}>
            {({ field, error }) => (
              <UzInput
                {...field}
                value={(field.value as string | null) ?? ''}
                label="Question"
                error={error}
                disabled={disabled}
              />
            )}
          </UzFormField>
          <UzFormField name={`faqs.${i}.answerHtml` as const}>
            {({ field }) => (
              <RichTextEditor
                value={(field.value as string | null) ?? ''}
                onChange={field.onChange}
                label="Answer"
                folder="category-pages"
                disabled={disabled}
              />
            )}
          </UzFormField>
        </RowShell>
      ))}
      <AddRowButton
        label="Add FAQ"
        disabled={disabled}
        onClick={() => append({ question: '', answerHtml: '' })}
      />
    </div>
  );
};
